import React from 'react';
import NumberFormat from 'react-number-format';
import {IEvent} from "../../interfaces/IEvent";


interface Props {
    value: number | undefined
    name: string
    precision?: number
    onChange: (event: IEvent) => void | null
    prefix?: string
    suffix?: string
    label?: string
}

const ReferenciaNumberField = (props: Props) => {
    const {value, name, precision, prefix = "", onChange, ...inputProps} = props;

    const decimalScale = precision != null ? precision : 0;

    const handleChange = (values) => {
        onChange({target: {name: name, value: values.floatValue}})
    };

    return (<>
        <NumberFormat 
            decimalScale={decimalScale}
            allowNegative={false}
            style={{textAlign:"left"}}
            prefix={prefix}
            sufix={inputProps.suffix}
            value={value}
            onValueChange={handleChange}
            {...inputProps}
        />
    </>);
};

export default ReferenciaNumberField;
